"use client";

import { ICONS_MODULES_PATHS } from "components/Layout/Sidebar/components/body/content/utils/iconModulesPath";
import { ExploreRankingModalV2 } from "components/ui/v2/explore/ExploreRankingModalV2";
import { UserItemRanking } from "components/ui/v2/explore/bundle/SideCard/UserItemRanking";
import { ICorporateValueRanking } from "gql/CorporateValues/queries";
import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";
import { EModalExploreType } from "types/Explorer.types";

export interface CorporateValueRankingModalV2Props {
  open: boolean;
  onClose: () => void;
  data: ICorporateValueRanking[];
}

export function CorporateValueRankingModalV2({
  open,
  onClose,
  data,
}: CorporateValueRankingModalV2Props) {
  const { t } = useTranslation("common");

  const description = useMemo(() => {
    if (data.length === 0) return undefined;
    return `${data.length} ${t("usuarios")}`;
  }, [data.length, t]);

  return (
    <ExploreRankingModalV2
      open={open}
      onClose={onClose}
      title={t("Ranking de valores")}
      iconSrc={ICONS_MODULES_PATHS.CONFIG.CORPORATE_VALUES}
      description={description}
    >
      <div className="flex flex-col gap-1">
        {data.map((r) => (
          <UserItemRanking
            key={`${r.user?.id}_recognitions_modal`}
            data={r.user}
            quantity={r.recognitions}
            type={EModalExploreType.RECOGNITION}
          />
        ))}
      </div>
    </ExploreRankingModalV2>
  );
}

export default CorporateValueRankingModalV2;
